export default "__VITE_ASSET__Bd4eMqER__"